import {
    DescriptionIcon,
    FaqIcon,
    FlagInfoIcon,
    InfoIcon,
    LampIcon,
    LocationDetailsIcon,
    QuestionIcon,
    ReviewIcon,
} from '@jsmdg/yoshi';

enum CaptionTitle {
    Default = 'Default',
    Description = 'Beschreibung',
    MoreDetails = 'Mehr Details',
    QuestionsAboutExperiences = 'Fragen zum Erlebnis',
    GeneralQuestions = 'Allgemeine Fragen',
    LocationDetails = 'Standortdetails',
    Faq = 'FAQ',
    Review = 'Kundenbewertungen',
    Accommodation = 'Die Unterkunft',
    UsefulInfo = 'Die wichtigsten Infos',
    HowItWorks = "So funktioniert's",
}

const captionIcons: Record<CaptionTitle, JSX.Element> = {
    [CaptionTitle.Default]: <LocationDetailsIcon className="mr-1-5x" />,
    [CaptionTitle.Description]: <DescriptionIcon className="mr-1-5x" />,
    [CaptionTitle.LocationDetails]: <LocationDetailsIcon className="mr-1-5x" />,
    [CaptionTitle.MoreDetails]: <InfoIcon className="mr-1-5x" />,
    [CaptionTitle.QuestionsAboutExperiences]: <QuestionIcon className="mr-1-5x" />,
    [CaptionTitle.Faq]: <FaqIcon className="mr-1-5x" />,
    [CaptionTitle.GeneralQuestions]: <QuestionIcon className="mr-1-5x" />,
    [CaptionTitle.Review]: <ReviewIcon className="mr-1-5x" />,
    [CaptionTitle.Accommodation]: <LocationDetailsIcon className="mr-1-5x" />,
    [CaptionTitle.UsefulInfo]: <FlagInfoIcon className="mr-1-5x" />,
    [CaptionTitle.HowItWorks]: <LampIcon className="mr-1-5x" />,
};

const getIcon = (caption: string): JSX.Element =>
    captionIcons[caption as CaptionTitle] || captionIcons[CaptionTitle.Default];

interface AccordionIconProps {
    readonly caption: string;
}

const AccordionIcon = ({ caption }: AccordionIconProps): JSX.Element => <>{getIcon(caption)}</>;

export { AccordionIcon, CaptionTitle };
